import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {AlertData} from './components/alerts/AlertContainer'

export interface CommonState {
  alerts: AlertData[]
}

const initialState: CommonState = {
  alerts: [],
}

const authRedux = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    pushAlert: (state, action: PayloadAction<AlertData>) => {
      state.alerts.push(action.payload)
    },
    removeAlert: (state, action: PayloadAction<string>) => {
      const alertIndex = state.alerts.findIndex((alert) => {
        return alert.key === action.payload
      })
      if (alertIndex >= 0) {
        state.alerts.splice(alertIndex, 1)
      }
    },
  },
})

export const actions = authRedux.actions
export const reducer = authRedux.reducer
